import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const emergentGoogle = () => {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      toast.success("Welcome back to SV Talent.");
      const to = r.user.role === "admin" ? "/admin" : r.user.role === "casting" ? "/dashboard/casting" : "/dashboard/talent";
      nav(loc.state?.from || to);
    } else toast.error(r.error);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0B]">
      <Header />
      <div className="max-w-md mx-auto px-4 py-16">
        <div className="sv-overline mb-3 text-center">Sign In</div>
        <h1 className="font-serif-hero text-4xl text-center">Welcome back.</h1>
        <form onSubmit={submit} className="mt-10 space-y-4">
          <input data-testid="login-email" required type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl focus:border-[#C5A059] outline-none" />
          <input data-testid="login-password" required type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-5 py-4 bg-[#1A1A1F] border border-[#5A2E2E] rounded-xl focus:border-[#C5A059] outline-none" />
          <button data-testid="login-submit" disabled={loading} className="sv-btn-primary w-full">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <div className="my-6 flex items-center gap-3 text-xs text-[#8A8478]">
          <div className="flex-1 h-px bg-[#5A2E2E]" />OR<div className="flex-1 h-px bg-[#5A2E2E]" />
        </div>
        <button data-testid="login-google" onClick={emergentGoogle}
          className="w-full py-4 border border-[#F4EFE4]/20 rounded-full text-sm hover:bg-[#1A1A1F] transition">Continue with Google</button>
        <p className="text-center text-sm text-[#8A8478] mt-6">
          <Link to="/forgot-password" data-testid="login-forgot" className="text-[#C5A059] hover:underline">Forgot password?</Link>
        </p>
        <p className="text-center text-sm text-[#8A8478] mt-4">
          New to SV Talent? <Link to="/register" data-testid="login-to-register" className="text-[#C5A059] font-medium">Join now</Link>
        </p>
      </div>
      <Footer />
    </div>
  );
}
